export default {
  VITE_API_BACKOFFICE: 'https://api.tolnkee.com/backoffice/v1',
  VITE_API_BACKUPS: 'https://api.tolnkee.com/api/backup/v1',
}